import { getPlatformName } from './platformName.es.js';
import { getSanitizedPageName } from './pageName.es.js';
import { getOfflineConversion } from './offlineConversionToCookies.es.js';

const getWindowWidth = (localWindow) => {
    return localWindow.document.documentElement
        ? localWindow.document.documentElement.clientWidth
        : localWindow.document.body.clientWidth;
};
const getGoogleAnalyticsClientId = () => {
    let clientId = null;
    if (window['ga']) {
        window['ga']((tracker) => (clientId = tracker.get('clientId')));
    }
    return clientId;
};
const getAnonymousId = () => {
    return (window &&
        window['analytics'] &&
        window['analytics'].user &&
        window['analytics'].user() &&
        window['analytics'].user().anonymousId());
};
/**
 * Return the URL for the page and strip the hash.
 */
function pageUrl(localWindow) {
    const url = localWindow.location.href;
    const i = url.indexOf('#');
    return i === -1 ? url : url.slice(0, i);
}
/**
 * Return the title for the page and strip characters outside (US-ASCII charset)
 * In practice, most HTTP header field values use only a subset of the US-ASCII charset [USASCII].
 * See https://datatracker.ietf.org/doc/html/rfc7230#section-3.2.4 for more information
 */
function pageTitle(localWindow) {
    // ASCII is in range of 0 to 127 in unicode (0x7F is 127 in hex)
    // eslint-disable-next-line no-control-regex
    return localWindow.document.title.replace(/[^\x00-\x7F]/g, '');
}
/**
 * @deprecated Use `getXLandrAnalyticsV2` instead that has a simpler API
 * and does not returned deprecated properties.
 */
const getXLandrAnalytics = (application, localWindow = window, platformNameOverride = undefined) => {
    const providerContexts = [
        {
            name: 'Segment',
            clientId: getAnonymousId(),
        },
        {
            name: 'GoogleAnalytics',
            clientId: getGoogleAnalyticsClientId(),
        },
    ].filter((p) => p.clientId);
    const pageInfo = {
        name: getSanitizedPageName(localWindow.location.pathname),
        path: localWindow.location.pathname,
        referrer: localWindow.document.referrer,
        search: localWindow.location.search,
        title: pageTitle(localWindow),
        url: pageUrl(localWindow),
        platform: platformNameOverride !== null && platformNameOverride !== void 0 ? platformNameOverride : getPlatformName(localWindow),
        application,
    };
    const offlineConversion = getOfflineConversion();
    // region deprecated
    const page = localWindow.location.pathname;
    const deviceResolution = {
        height: localWindow.screen.height,
        width: localWindow.screen.width,
        devicePixelRatio: localWindow.devicePixelRatio,
    };
    const windowResolution = {
        height: localWindow.innerHeight,
        width: getWindowWidth(localWindow),
        devicePixelRatio: localWindow.devicePixelRatio,
    };
    const screenColors = localWindow.screen.colorDepth;
    // endregion
    return {
        providerContexts,
        pageInfo,
        // deprecated
        deviceResolution,
        windowResolution,
        screenColors,
        page,
        offlineConversion,
    };
};
const getXLandrAnalyticsV2 = (application, options) => {
    var _a, _b, _c, _d;
    const providerContexts = [
        {
            name: 'Segment',
            clientId: (_a = options === null || options === void 0 ? void 0 : options.overrideAnonymousId) !== null && _a !== void 0 ? _a : getAnonymousId(),
        },
        {
            name: 'GoogleAnalytics',
            clientId: (_b = options === null || options === void 0 ? void 0 : options.overrideGoogleAnalyticsClientId) !== null && _b !== void 0 ? _b : getGoogleAnalyticsClientId(),
        },
    ].filter((p) => p.clientId);
    const localWindow = (_c = options === null || options === void 0 ? void 0 : options.overrideWindow) !== null && _c !== void 0 ? _c : window;
    const pageInfo = {
        name: getSanitizedPageName(localWindow.location.pathname),
        path: localWindow.location.pathname,
        referrer: localWindow.document.referrer,
        search: localWindow.location.search,
        title: pageTitle(localWindow),
        url: pageUrl(localWindow),
        platform: (_d = options === null || options === void 0 ? void 0 : options.overridePlatformName) !== null && _d !== void 0 ? _d : getPlatformName(localWindow),
        application,
    };
    const offlineConversion = !(options === null || options === void 0 ? void 0 : options.disableOfflineConversion) ? getOfflineConversion() : undefined;
    return {
        offlineConversion,
        pageInfo,
        providerContexts,
    };
};

export { getAnonymousId, getGoogleAnalyticsClientId, getXLandrAnalytics, getXLandrAnalyticsV2 };
